import { render, staticRenderFns } from "./AccountSettingsMainDialog.vue?vue&type=template&id=815b2060&scoped=true&"
import script from "./AccountSettingsMainDialog.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815b2060",
  null
  
)

export default component.exports